import { api } from "./api";

export type Brand = {
  title: string;
  backgroundImageUrl: string;
  smallLogoUrl: string;
  bannerImage?: string;
  bannerTitle?: string;
  bannerDescription?: string;
  copywriteNotice?: string;
  addressHeading?: string;
  address?: string;
};

export type Hero = {
  heading1: string;
  heading2: string;
  body1: string;
  product?: Product | null;
};

export type ProductImage = {
  fileName: string;
  url: string;
};

export type Product = {
  id: string;
  name: string;
  priceInCents: string;
  abv: number;
  description: string;
  imageMasterUrl: string;
  images: ProductImage[];
  showBuyButton: boolean;
  ibu?: number;
  basePrice?: number;
  ed?: number;
  preBookings?: boolean;
  displayInHomepage?: boolean;
  _id?: string;
  primaryButtonTitle?: string;
  secondaryButtonTitle?: string;
  displayInHome?: boolean;
  preorder?: boolean;
};

// HomePage Type
export type HomePageData = {
  brand?: Brand;
  hero?: Hero;
  products: Product[];
  prebook: Product[];
};

export const fetchHomepageData = async (): Promise<HomePageData> => {
  try {
    const response = await api.get("home");
    const data = response.data?.data ?? {};
    const processedPrebook = (data.prebook ?? []).filter(Boolean);
    return {
      brand: data.brand ?? {
        title: "",
        backgroundImageUrl: "",
        smallLogoUrl: "",
      },
      hero: data.hero ?? {
        heading1: "",
        heading2: "",
        body1: "",
      },
      products: (data.products ?? []).filter(Boolean),
      prebook: processedPrebook,
    };
  } catch (error: any) {
    console.error(
      "Error fetching homepage data:",
      error.response?.data || error.message
    );

    return {
      brand: { title: "", backgroundImageUrl: "", smallLogoUrl: "" },
      hero: { heading1: "", heading2: "", body1: "" },
      products: [],
      prebook: [],
    };
  }
};
